module.exports = __webpack_public_path__ + "static/img/wangxinyuan3.fe4ab5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/wangxinyuan3.jpg
// module id = oAZR
// module chunks = 1